import { render, staticRenderFns } from "./emptyNoStore.vue?vue&type=template&id=0c78b5b0&scoped=true"
import script from "./emptyNoStore.vue?vue&type=script&lang=js"
export * from "./emptyNoStore.vue?vue&type=script&lang=js"
import style0 from "./emptyNoStore.vue?vue&type=style&index=0&id=0c78b5b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c78b5b0",
  null
  
)

export default component.exports